module.exports = __webpack_public_path__ + "img/plus--light.ff5dc792.svg";